export default "__VITE_ASSET__cb8a126b__"